import { EVENT_PAGE_LOAD } from '../../../hooks/useTracking/events/eventTypes.js';
import { buildVirtualPath, getDeviceType, getOperatingSystem, getScreenOrientation } from '../../../hooks/useTracking/utils/index.js';
export const action = payload => ({
  type: EVENT_PAGE_LOAD,
  payload
});
export const handler = action => {
  return {
    virtpath: buildVirtualPath(action.payload.page, action.payload.portal),
    global_environment: process.env.STAGE || '',
    global_osname: getOperatingSystem(),
    global_devicetype: getDeviceType(),
    pagetype: 'LOGIN',
    screen_orientation: getScreenOrientation() || ''
  };
};